import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import {reducer} from './store';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppHttpInterceptor} from './interceptors/app-http-interceptor';
import {UiUtilsModule} from './ui-utils/ui-utils.module';
import {AngularSvgIconModule} from 'angular-svg-icon';
import {DialogService} from 'primeng/dynamicdialog';
import {PersistanceService} from './services/persistance.service';
import {MessageService} from 'primeng/api';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {CustomPreset} from './CustomThemePreset';

@NgModule({
  declarations: [
    AppComponent,
  ],
  bootstrap: [AppComponent],
  imports: [BrowserModule,
    AppRoutingModule,
    StoreModule.forRoot({app: reducer}),
    BrowserAnimationsModule,
    UiUtilsModule,
    AngularSvgIconModule.forRoot()],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true},
    DialogService,
    PersistanceService,
    MessageService,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: CustomPreset,
        options: {
          darkModeSelector: false,
        }
      }
    }),
  ]
})
export class AppModule {
}
